export default function Footerbar() {
    return (
        <footer>©{(new Date().getFullYear())} Tyler Higgs</footer>
    )
};